// 注意：strrole.ts文件里面调用的window，是指向生成top.pathStrrole的页面的window
// 也就是说，例如location相关的全局变量，取的是生成top.pathStrrole的页面的window.location
// 所以，strrole.ts文件里面，要慎用window.x变量，除非调用的window.x，其它页面返回值也是一样的，才可使用
const strrole = {
  '/OutgoingRegistration/PollingTable': function () {
    return [
        "a12", "a1205", "a1201", "a1202", "a120102", "a120202", "a1203", "a1204", "a1206", "a120402", "a120403", "a1207", "a1205001", "a1208", "a120801", "a120802", "a120803"
    ]
  },
  'OutgoingRegistration/DispatchOrder': function () {
    return [
        "a1201", "a1202", "a120102", "a120202", "a1203", "a1204", "a1205", "a1206", "a1207", "a120201", "a120101", "a1208", "a120801", "a120802", "a120803"
    ]
  },
  '/OutgoingRegistration/UNIT_BILLNO': function () {
    return [
        "a12", "a1205", "a1201", "a1202", "a120102", "a120202", "a1203", "a1204", "a1206", "a120402", "a120403", "a1207"
    ]
  },
  '/OutgoingRegistration/ORDERNO_BILLNO': function () {
    return [
        "a12", "a1205", "a1201", "a1202", "a120102", "a120202", "a1203", "a1206", "a1207", "a1208", "a120801", "a120802", "a120803"
    ]
  },
  '/OutgoingRegistration/HomeAgent': function ({ ingettype }) {
    if(ingettype == 0){
        return [
            "a15", "a1501", "a1502", "a1503", "a1504", "a1505", "a1506", "a1507", "a1508", "a1509", "a1510", "a1516", "a1517"
        ]
    }else{
        return [
            "a115", "a1501", "a11502", "a11503", "a11504", "a11505", "a11506", "a11507", "a11508", "a11509", "a1510", "a11514", "a11515"
        ]
    }
  },
  '/OutgoingRegistration/CompleteMiddle': function ({ ingettype }) {
    if(ingettype == 0){
        return [
            "a1508", "c1301", "a1514", "a1515"
        ]
    }else{
        return [
            "a11508", "c1301", "a11512", "a11513"
        ]
    }
  },
  '/OutgoingRegistration/MiddleOutStock': function ({ ingettype }) {
    if(ingettype == 0){
        return [
            "a1508"
        ]
    }else{
        return [
            "a11508"
        ]
    }
  },
  '/OutgoingRegistration/DeliveryRecord': function ({ ingettype }) {
    if(ingettype == 0){
        return [
            "a150701", "a150702", "a150703"
        ]
    }else{
        return [
            "a1150701", "a1150702", "a1150703"
        ]
    }
  },
  '/OutgoingRegistration/DeliveryRecordDetail': function ({ ingettype }) {
    if(ingettype == 0){
        return [
            "a15070401", "a15070402", "a15070403", "a15070404", "a150702", "a1508"
        ]
    }else{
        return [
            "a115070401", "a115070402", "a115070403", "a115070404", "a1150702", "a11508"
        ]
    }
  },
  '/OutgoingRegistration/SingleMiddle': function ({ ingettype }) {
    if(ingettype == 0){
        return [
            "a1502", "a1503", "a1507"
        ]
    }else{
        return [
            "a11502", "a11503", "a11507"
        ]
    }
  },
  '/OutgoingRegistration/BatchMiddle': function () {
    return [
        "a1509", "a11509", "a1508", "a11508"
    ]
  },
  '/Billing/Index': function () {
    const tmscode = window.getNewUserInfo().TMSCode
    if(tmscode == "85473"){
        return [
            "a1329"
        ]
    }else{
        return []
    }
  },
  '/Billing/Index2': function () {
    return [
        "a1308", "a1312", "a1317", "a1318", "a1319", "a1320","a1318"
    ]
  },
  '/Billing/UnitCheck': function () {
    return [
        "c1316", "c131601", "c131602", "c131603", "c131604"
    ]
  },
  '/Billing/AccCheck': function () {
    return [
        "c1318", "c131801", "c131802", "c131803"
    ]
  },
  '/Billing/CancelBill': function () {
    return [
        "c1317", "c131701", "c131702", "c131703"
    ]
  },
  '/Billing/ReturnBill': function () {
    return [
        "c1320", "c132001", "c132002"
    ]
  },
  '/waybillImport/ImportRecord': function () {
    return [
        "a1101", "a1103", "a1104"
    ]
  },
  '/waybillImport/ImportRecord80548': function () {
    return [
        "a1101", "a1103", "a1104"
    ]
  },
  '/fdpz/Index': function () {
    return [
        "a1802", "a1803", "a1804", "a180314", "a1806", "a181001", "a181002", "a181003", "a181004", "a181005", "a181006", "a181007"
    ]
  },
  '/fdpz/fdpzADDSecondStep': function () {
    return [
        "a1802", "a1805", "a1806"
    ]
  },
  '/fdpz/fdpzUPD': function () {
    return [
        "a1803", "a1804", "a1805", "a180301", "a180302", "a180303", "a180304", "a180305", "a180306", "a180307", "a180308", "a180309", "a180310", "a180311", "a180312", "a180313", "a180311_dz"
    ]
  },
  '/fdpz/fdpzUPD_bcqd': function () {
    return [
        "a180314", "a180303", "a180315"
    ]
  },
  '/fdpz/fdpz_ypz': function () {
    return [
        "a180701", "a180702", "a180703", "a180704"
    ]
  },
  '/FinancialReconciliation/CustomerReconciliation_F9': function () {
    return [
        "c120101", "c120102"
    ]
  },
  '/FinancialReconciliation/ReconciliationBill': function () {
    return [
        "c120201", "c120202", "c120203", "c120204", "c120205", "c120206", "c120208", "c1202061", "c1202062", "c1202063", "c120209", "c120210", "c120211", "c120212"
    ]
  },
  '/FinancialReconciliation/ReconciliationBill_Detailed': function () {
    return [
        "c120101", "c120102", "c120205", "c120207"
    ]
  },
  '/FinancialReconciliation/ReconciliationBill_Detailed_DPM': function () {
    return [
        "c120205"
    ]
  },
  '/FinancialReconciliation/BranchReconciliation_F9': function () {
    return [
        "c120101", "c120102"
    ]
  },
  '/FinancialReconciliation/BranchReconciliationBill': function () {
    return [
        "c120201", "c120202", "c120203", "c120204", "c120205"
    ]
  },
  '/FinancialReconciliation/BranchReconciliationBill_Detailed': function () {
    return [
        "c120205"
    ]
  },
  '/FinancialReconciliation/AgentReconciliation': function () {
    return [
        "c120301", "c120302"
    ]
  },
  '/FinancialReconciliation/AgentReconciliationBill_DetailedAdd': function () {
    return [
        "c120301", "c120302"
    ]
  },
  '/FinancialReconciliation/AgentReconciliationBill': function () {
    return [
        "c120401", "c120402", "c120403", "c120404", "c120405", "c120408"
    ]
  },
  '/FinancialReconciliation/AgentReconciliationBill_Detailed': function () {
    return [
        "c120405", "c120407"
    ]
  },
  '/FinancialReconciliation/CoachReconciliation': function () {
    return [
        "c120501", "c120502", "c120503", "c120504", "c120505"
    ]
  },
  '/FinancialReconciliation/ShorthaulReconciliation': function () {
    return [
        "c120601", "c120602", "c120603", "c120604", "c120605"
    ]
  },
  '/FinancialReconciliation/Company_ReconciliationBill': function () {
    return [
        "c120801", "c120802", "c120803"
    ]
  },
  '/FinancialReconciliation/COMPANY_ReconciliationBill_Detailed': function () {
    return [
        "c120803"
    ]
  },
  '/FinancialReconciliation/Track': function () {
    return [
        "c120208", "c12020801", "c12020802"
    ]
  },
  '/FinancialReconciliation/ResidentsReconciliation': function () {
    return [
        "c120901", "c120902"
    ]
  },
  '/FinancialReconciliation/ResidentreconciliationBill': function () {
    return [
        "c121001", "c121002", "c121003", "c121004", "c121005"
    ]
  },
  '/FinancialReconciliation/SFReconciliation': function () {
    return [
        "c121101", "c121102"
    ]
  },
  '/FinancialReconciliation/SFReconciliationBill': function () {
    return [
        "c121201", "c121202", "c121203", "c121204", "c121205"
    ]
  },
  '/FinancialReconciliation/SFReconciliationBill_Detailed': function () {
    return [
        "c121205"
    ]
  },
  '/FinancialReconciliation/CustomerReconciliationYdz_F9': function () {
    return [
        "c121301", "c121302"
    ]
  },
  '/FinancialReconciliation/ReconciliationBillYdz': function () {
    return [
        "c121401", "c121402", "c121403", "c121404", "c121405"
    ]
  },
  '/FinancialReconciliation/ReconciliationBill_DetailedYdz': function () {
    return [
        "c121403", "c121404"
    ]
  },
  '/FinancialReconciliation/AgentReconciliationYdz': function () {
    return [
        "c121501", "c121502"
    ]
  },
  '/FinancialReconciliation/AgentReconciliationBill_DetailedYdz': function () {
    return [
        "c121604", "c121603"
    ]
  },
  '/FinancialReconciliation/AgentReconciliationBillYdz': function () {
    return [
        "c121601", "c121602", "c121603", "c121604", "c121605"
    ]
  },
  '/DeliveryRecord/Index': function () {
    return [
        "a11401", "a11402", "a11403", "a11404", "a11405", "a11406", "a11407", "a11408", "a11409", "a11410", "a11411", "a11412", "a11413", "a11414", "a11416", "a11417", "a150705"
    ]
  },
  '/DeliveryRecord/ArrangeDelivery': function () {
    return [
        "a11401", "a11402", "a11403", "a11404", "a11405", "a11406", "a11407", "a11408", "a11409", "a11410", "a11411", "a11412", "a11413", "a11414", "a1308"
    ]
  },
  '/DeliveryRecord/GenerateDeliveryNote': function () {
    return [
        "a11401", "a11402", "a11403", "a11404", "a11405", "a11406", "a11407", "a11408", "a11409", "a11410", "a11411", "a11412", "a11413", "a11414", "a1308"
    ]
  },
  '/DeliveryRecord/Deliverymodify': function () {
    return [
        "a11401", "a11402", "a11403", "a11404", "a11405", "a11406", "a11407", "a11408", "a11409", "a11410", "a11411", "a11412", "a11413"
    ]
  },
  '/DeliveryRecord/SendDeliverymodify': function () {
    return [
        "a11401", "a11402", "a11403", "a11404", "a11405", "a11406", "a11407", "a11408", "a11409", "a11410", "a11411", "a11412", "a11413", "a11418"
    ]
  },
  '/priceSystem/Index': function () {
    return [
        "n1202"
    ]
  },
  '/priceSystem/Index_80799': function () {
    return [
        "n1202"
    ]
  },
  '/priceSystem/Index2': function () {
    return [
        "n1201"
    ]
  },
  '/priceSystem/safeindex': function () {
    return [
        "n1202"
    ]
  },
  '/priceSystem/TransitIndex': function () {
    return [
        "n1201"
    ]
  },
  '/priceSystem/Jincangindex79710': function () {
    return [
        "n1201"
    ]
  },
  '/priceSystem/Index_81930': function () {
    return [
        "n1202"
    ]
  },
  '/priceSystem/Index_96209': function () {
    return [
        "n1202"
    ]
  },
  '/priceSystem/tsprice': function () {
    return [
        "n1219"
    ]
  },
  '/priceSystem/addedittsprice': function () {
    return [
        "n1219"
    ]
  },
  '/newCW/Index': function () {
    return [
        "c16", "c110902", "c110903", "c110904", "c110908", "c110909", "c111002", "c111003", "c111004", "c111008", "c111009", "c111002", "c111003", "c111004", "c111005", "c111008", "c111009", "c110402", "c110403", "c110404", "c110409", "c110410", "c110406", "c110905", "c111006"
    ]
  },
  '/printbq/quickPrintbq': function () {
    return [
        "a132201", "a132202", "a132203", "a132204", "a132205", "a132206", "a132207"
    ]
  },
  '/printbq/batchPrePrintbq': function () {
    return [
        "a132201", "a132202", "a132203", "a132204", "a132205", "a132206", "a132207"
    ]
  },
  '/printbq/batchPrePrintbqAddOrEdit': function () {
    return [
        "a132201", "a132202", "a132203", "a132204", "a132205", "a132206", "a132207"
    ]
  },
  '/ReportTpl/Index': function () {
    return [
        "c1701", "c170101", "c1702", "c1703", "c1704", "c1705", "c1706", "c1707", "c1708", "c1709", "c1710", "c140102", "c140303", "c140101", "c140115",
        "c140103","c140104","c140105","c140106","c14010601","c14010602","c14010603","c14010604","c14010605","c140107","c140108","c140109","c140110","c14011001","c14011002","c140402","c140403","c140404","c140406","c140407","c140408","c140409","c140410",
        "c140405","c140502","c140503","c140504","c140601","c140501","c140401","b15","b1602","b1603","b1604","b1605","b1608","b1609","c140505","c140506","c140111","c140116","c140115",
        "c140112","c140113","c14010606","c14010607","c140507","c1301","c1320","c140118"
    ]
  },
  '/ReportTpl/ReportTpl_turnoverMain': function () {
    return [
        "c140102"
    ]
  },
  '/ReportTpl/ReportAnalyze': function () {
    return [
        "c140301", "c140302"
    ]
  },
  '/CustomerProfiles/CustomerArrangement': function () {
    return [
        "h1101", "h1102", "h1103", "h1104", "h1105", "h1106", "h1107"
    ]
  },
  '/CustomerProfiles/CustomerInformation': function () {
    return [
        "h1201", "h120101", "h120102", "h120103", "h120104", "h120105", "h120106", "h120107", "h1202", "h120201", "h120202", "h120203", "h120204", "h120205", "h120206", "h1203", "h120301", "h120302", "h120303", "h120304", "h1204", "h120401", "h120402", "h120403", "h120404", "h1205", "h120501", "h120502", "h120503", "h120504", "h120601", "h120602", "h120603", "h120207"
    ]
  },
  '/CustomerProfiles/SCAdded': function ({ page }) {
    if(page == "客户整理模块") {
        return [
            "h1107"
        ]
    } else if (page == "客户资料模块") {
        return [
            "h120107"
        ]
    } else {
        return []
    }
  },
  '/CustomerProfiles/CustomerRetention': function ({ page }) {
    if(page == "收货方模块") {
        return [
            "h120207"
        ]
    } else if (page == "客户整理收货方") {
        return [
            "h1108"
        ]
    } else {
        return []
    }
  },
  '/WebOrder/Index': function () {
    return [
        "a117", "a11701", "a11702", "a11703", "a11704", "a11705"
    ]
  },
  '/WTTX/CooperativeCarrier': function () {
    return [
        "g101"
    ]
  },
  '/WTTX/ApplicationRecord': function () {
    return [
        "g10201", "g10202", "g10203"
    ]
  },
  '/WTTX/OrderHistory': function () {
    return [
        "g10401", "g10402", "g10403", "g10404"
    ]
  },
  '/AcceptanceOfBill/Index': function () {
    return [
        "a1301", "a1302", "a1303", "a1304", "a1305", "a1306", "a1307", "a1308", "a1309", "a1310", "a1308", "a1312", "a1321", "a11", "a1322", "a1323", "a1324", "a1325", "q125", "a1326", "a1327", "q201", "a11410"
    ]
  },
  '/AcceptanceOfBill/GridDPM': function () {
    return [
        "a1301", "a1302", "a1303", "a1304", "a1305", "a1306", "a1307", "a1308", "a1309", "a1310", "a1312", "a1321", "a11", "a1322", "a1327", "a1323"
    ]
  },
  '/CheckSheet/FleetIndex': function () {
    return [
        "e19", "e1901", "e1902", "e1903", "e1904"
    ]
  },
  '/ArrivalInventory/Index': function () {
    return [
        "a11201", "a11202", "a11204", "q101", "a11205", "a11206", "a11207", "a11208", "a11209"
    ]
  },
  '/sysMana/GRIDMANA': function () {
    return [
        "n140401", "n140402", "n140403"
    ]
  },
  '/dhqr/Index': function () {
    return [
        "a11101", "a11102", "a11103", "a11104", "a11105", "a11106", "a11107", "a11108", "a11111", "a1110801", "a1110802", "a11109", "a1110901", "a1110902", "a11110"
    ]
  },
  '/dhqr/InventoryInTransit': function () {
    return [
        "a11104", "a11105", "a11107", "a1110601", "a1110602", "a1110603", "a1110604", "a1110605", "a1110606", "q101", "a111060201", "a111060202", "a111060203", "a11110", "a11111"
    ]
  },
  '/bankPrepare/Index': function () {
    return [
        "c150502", "c150503", "c150504"
    ]
  },
  '/bankPrepare/CustomAccount': function () {
    return [
        "c150601", "c150602", "c150603", "c150604"
    ]
  },
  '/bankPrepare/PaymentMethod': function () {
    return [
        "c150702", "c150703", "c150704"
    ]
  },
  '/TruckPositioning/MyGPSAccountInfo': function () {
    return [
        "l10501"
    ]
  },
  '/TruckPositioning/LocateTheQuery': function () {
    return [
        "l10101", "l10102"
    ]
  },
  '/TruckPositioning/ConsumptionRecords': function () {
    return [
        "l10201"
    ]
  },
  '/TruckPositioning/TopUpRecords': function () {
    return [
        "l105", "l10301"
    ]
  },
  '/TruckPositioning/QueryRecords': function () {
    return [
        "l10401"
    ]
  },
  '/SLManage/DriverIndex': function () {
    return [
        "kp21", "kp211", "kp212"
    ]
  },
  '/SLManage/CarIndex': function () {
    return [
        "kp22", "kp221", "kp222"
    ]
  },
  '/SLManage/OrderList': function () {
    return [
        "kp23", "kp231", "kp232"
    ]
  },
  '/Payment/PaymentIndex': function () {
    return [
        "c1112"
    ]
  },
  '/Payment/PaymentConfirm': function () {
    return [
        "c1113"
    ]
  },
  '/LibraryTemplate/LibraryTemplateMana': function () {
    return [
        "jck901", "jck902", "jck903"
    ]
  },
  '/GoodsTrackingTemplate/GoodsTrackingTemplateMana': function () {
    return [
        "n140501", "n140502", "n140503"
    ]
  },
  '/CustomerRecKpi/Index': function () {
    return [
        "m1501", "m1502", "m1503", "m1504"
    ]
  },
  '/CustomerRecKpi/CustomerRecReport': function () {
    return [
        "m1601"
    ]
  },
  '/CustomerInformationTemplate/CustomerInformationTemplateMana': function () {
    return [
        "n140301", "n140302", "n140303"
    ]
  },
  '/CashClassReport/CashSZReport': function () {
    return [
        "c1702", "c170201", "c170202"
    ]
  },
  '/Arbitration/ArbitrationManage': function () {
    return [
        "i1401", "i1402", "i1403", "i1404", "i1405", "i1406", "i1407"
    ]
  },
  '/VehicleXinghao/wheelManagement': function () {
    return [
        "e18dz01", "e18dz02", "e18dz03", "e18dz04", "e18dz05", "e18dz06"
    ]
  },
  '/ClaimsSettlement/ClaimsSettlementApply': function () {
    return [
        "i1201", "i1202", "i1203", "i1204", "i1205", "i1206", "i1207", "i1208", "i1209", "i1210", "i1211", "i1212", "i1213","i1214"
    ]
  },
  '/BillManagement/BillWarehousingList': function () {
    return [
        "o10201", "o10202", "o10203"
    ]
  },
  '/BillManagement/BillCollarUseList': function () {
    return [
        "o10401", "o10402", "o10403"
    ]
  },
  '/BillManagement/BillDistributionList': function () {
    return [
        "o10301", "o10302", "o10303"
    ]
  },
  '/BillManagement/BillList': function () {
    return [
        "o10501", "o10502"
    ]
  },
  '/BillManagement/BillDetail': function () {
    return [
        "o1050101", "o1050102", "o1050103"
    ]
  },
  '/BillManagement/BillType': function () {
    return [
      	"o10101", "o10102"
    ]
  },
  '/Warehous80548/qgdlinfo80548': function () {
    return [
        "r102_80548", "r103_80548", "r104_80548"
    ]
  },
  '/Warehous80548/rkdinfo80548': function () {
    return [
        "r202_80548", "r203_80548", "r204_80548", "r205_80548", "r206_80548", "r207_80548"
    ]
  },
  '/OP/ImportRecord': function () {
    return [
        "e1205", "e120501", "e120502", "e120503"
    ]
  },
  '/OP/OPTemplate': function () {
    return [
        "e120501", "e120502", "e120503"
    ]
  },
  '/ImportTemplate/ImportTemplateMana': function () {
    return [
        "n140201", "n140202", "n140203"
    ]
  },
  '/ImportTemplate/ImportMiddleTemplateMana': function () {
    return [
        "n141501", "n141502", "n141503"
    ]
  },
  '/BillingCustom/BillingNew': function () {
    return [
        "a1308", "a1309", "a1312", "a1317", "a1318", "a1319", "a1320", "a1321", "c130101", "c130102", "c130103", "q203", "c130106", "a1328", "c130107", "c130108", "c130109","c130110"
    ]
  },
  '/Courier/warehousingManagement': function () {
    return [
        "s10102", "s10103", "s10104", "s10105", "s10106"
    ]
  },
  '/Courier/warehousingDetails': function () {
    return [
        "s10201"
    ]
  },
  '/QualityManage/ProblemShipment': function () {
    return [
        "i110101", "i110102", "i110103", "i110104", "i110105", "i110106", "i110107", "i110108", "i110110"
    ]
  },
  '/QualityManage/AsterShipment': function () {
    return [
        "i110301", "i110302", "i110303", "i110304", "i110305", "i110306", "i110307", "i110308", "i110309", "i110310"
    ]
  },
  '/QualityManage/NoHeaderfileShipment': function () {
    return [
        "i110201", "i110202", "i110203", "i110204", "i110205", "i110206", "i110207", "i110208", "i110209", "i110210", "i110211", "i110212","i110213"
    ]
  },
  '/QualityManage/RewardspenaltiesShipment': function () {
    return [
        "i1301", "i1302", "i1303", "i1304", "i1305", "i1306", "i1307", "i1308"
    ]
  },
  '/paymentWelfare/payroll': function () {
    return [
        "k2101", "k2102", "k2103", "k2104"
    ]
  },
  '/fhkc/Index': function () {
    return [
        "q101", "a1401", "a1402", "a1403", "a1404", "a1406"
    ]
  },
  '/Productlibrary/MaterielIndex': function () {
    return [
        "jck101", "jck102", "jck103", "jck104", "jck105", "jck106"
    ]
  },
  '/Productlibrary/MaterielMainIndex': function () {
    return [
        "jck101", "jck102", "jck103", "jck104", "jck105","jck106"
    ]
  },
  '/Productlibrary/ChangecoefficientMainIndex': function () {
    return [
        "jck201", "jck202", "jck203", "jck204", "jck205","jck206"
    ]
  },
  '/Productlibrary/ChangecoefficientIndex': function () {
    return [
        "jck201", "jck202", "jck203", "jck204", "jck205", "jck206"
    ]
  },
  '/Productlibrary/SVolumeMainIndex': function () {
    return [
        "jck301", "jck302", "jck303", "jck304", "jck305", "jck306"
    ]
  },
  '/Productlibrary/SVolumeIndex': function () {
    return [
        "jck301", "jck302", "jck303", "jck304", "jck305", "jck306"
    ]
  },
  '/Productlibrary/SPricelistMainIndex': function () {
    return [
        "jck401", "jck402", "jck403", "jck404", "jck405", "jck406"
    ]
  },
  '/Productlibrary/SPricelistIndex': function () {
    return [
        "jck401", "jck402", "jck403", "jck404", "jck405", "jck406"
    ]
  },
  '/Productlibrary/GzCientIndex': function () {
    return [
        "jck501", "jck502", "jck503", "jck504", "jck505","jck506"
    ]
  },
  '/Productlibrary/HfClientIndex': function () {
    return [
        "jck601", "jck602", "jck603", "jck604", "jck605", "jck606"
    ]
  },
  '/PersonnelAdministration/WorkHard': function () {
    return [
        "k1301", "k1302", "k1303", "k1304"
    ]
  },
  '/PersonnelAdministration/LeaveRegistration': function () {
    return [
        "k1401", "k1402", "k1403", "k1404"
    ]
  },
  '/PersonnelAdministration/TrainingRegistration': function () {
    return [
        "k1502", "k1503", "k1504"
    ]
  },
  '/PersonnelAdministration/IIDeclaration': function () {
    return [
        "k1602", "k1603", "k1604"
    ]
  },
  '/PersonnelAdministration/PromotionMobilization': function () {
    return [
        "k1702", "k1703", "k1704"
    ]
  },
  '/PersonnelAdministration/BPRegister': function () {
    return [
        "k1802", "k1803", "k1804"
    ]
  },
  '/PersonnelAdministration/StaffAppraisal': function () {
    return [
        "k1902", "k1903", "k1904"
    ]
  },
  '/PersonnelAdministration/department': function () {
    return [
        "k301", "k302"
    ]
  },
  '/PersonnelAdministration/education': function () {
    return [
        "k40102"
    ]
  },
  '/PersonnelAdministration/job': function () {
    return [
        "k40201", "k40202", "k40203", "k40204"
    ]
  },
  '/PersonnelAdministration/staffingTpl': function () {
    return [
        "k1202","k1203","k1204","k1302", "k1303", "k1304", "k1402", "k1403", "k1404", "k1502", "k1503", "k1504", "k1602", "k1603", "k1604"
        , "k1702", "k1703", "k1704", "k1802", "k1803", "k1804", "k1902", "k1903", "k1904", "k2002", "k2003", "k2004", "k2202", "k2203", "k2204", "k2302", "k2303", "k2304"
    ]
  },
  '/OtherFee/OtherFeeList': function () {
    return [
        "c1320"
    ]
  },
  '/Feedback/LQFeedback': function () {
    return [
      	"n130101", "n130102"
    ]
  },
  '/Cashier/CashierAuditing': function () {
    return [
        "c111101", "c111102"
    ]
  },
  '/Cashier/CashierZZ': function () {
    return [
        "c111501", "c111502"
    ]
  },
  '/CashDayAccount/CashDayAccount_Index': function ({ billtype }) {
    if(billtype == 0){
        return [
            "c110902", "c110903", "c110904", "c110905", "c110906", "c110907", "c110908", "c110909", "c110910", "c110911"
        ]
    }else{
        return [
            "c111002", "c111003", "c111004", "c111005", "c111006", "c111007", "c111008", "c111009", "c111010", "c111011"
        ]
    }
  },
  '/AccountStatemen/MainIndex': function () {
    return [
        "jck701", "jck702", "jck703"
    ]
  },
  '/AccountStatemen/Index': function () {
    return [
        "jck801", "jck802", "jck803"
    ]
  },
  '/AccountStatemen/StatementIndex': function () {
    return [
        "jck801", "jck802"
    ]
  },
  '/Home/IndexNew': function () {
    return [
        "n130202", "q3", "q301"
    ]
  },
  '/Home/IndexNewTwo': function () {
    return [
        "q304", "q30401", "q30402", "q30403", "q30404", "q30405", "q30406", "q30407", "q30408", "q30409", "q307", "q307", "q30701", "q30702", "q30703", "q30704", "q302", "q306", "q30601", "q30602", "q301", "q30604", "q30605", "q30606", "q30607", "q30608", "q30609", "q305", "q30501", "q30502", "q30503", "q30504", "q30505", "q30506", "q30507", "q30508", "n130202", "q3", "q308", "q309"
    ]
  },
  '/Home/IndexNewTwoV2': function () {
    return [
        "q304", "q30401", "q30402", "q30403", "q30404", "q30405", "q30406", "q30407", "q30408", "q30409", "q307", "q307", "q30701", "q30702", "q30703", "q30704", "q302", "q306", "q30601", "q30602", "q301", "q30604", "q30605", "q30606", "q30607", "q30608", "q30609", "q305", "q30501", "q30502", "q30503", "q30504", "q30505", "q30506", "q30507", "q30508", "n130202", "q3", "q308", "q309"
    ]
  },
  '/Home/Index4': function () {
    return [
        "q304", "q30401", "q30402", "q30403", "q30404", "q30405", "q30406", "q30407", "q30408", "q30409", "q307", "q307", "q30701", "q30702", "q30703", "q30704", "q302", "q306", "q30601", "q30602", "q301", "q30604", "q30605", "q30606", "q30607", "q30608", "q30609", "q305", "q30501", "q30502", "q30503", "q30504", "q30505", "q30506", "q30507", "q30508", "n130202", "q3"
    ]
  },
  '/MyAccount/AccountInfo': function () {
    return [
        "d120102", "d120103", "d120104", "d120105"
    ]
  },
  '/MyAccount/AccountChange': function () {
    return [
        "d1206", "d120702", "d120703", "d120704", "d120705"
    ]
  },
  '/MyAccount/AccountChange_79323': function ({ type }) {
    if(type == 0){
        return [
            "d1106", "d1107", "d110703", "d110704", "d110702"
        ]
    }else{
        return [
            "d1206", "d1207", "d120703", "d120704", "d120702"
        ]
    }
  },
  '/MyAccount/AccountRechargeRecord': function () {
    return [
        "d120402", "d120403", "d120404", "d120405"
    ]
  },
  '/MyAccount/AccountProRate': function () {
    return [
        "d120802", "d120803"
    ]
  },
  '/MyAccount/AccountCapital': function () {
    return [
        "d1210"
    ]
  },
  '/MyAccount/intervalSetting': function () {
    return [
        "n1208"
    ]
  },
  '/MyAccount/GroundLine': function () {
    return [
        "n1209"
    ]
  },
  '/MyAccount/Upstairs': function () {
    return [
        "n1209"
    ]
  },
  '/MyAccount/Unload': function () {
    return [
        "n1209"
    ]
  },
  '/MyAccount/OtherExpenses': function () {
    return [
        "n1209"
    ]
  },
  '/MyAccount/Delivery': function () {
    return [
        "n1209"
    ]
  },
  '/MyAccount/SettlementTransfer': function () {
    return [
        "n1209"
    ]
  },
  '/MyAccount/SettlementDelivery': function () {
    return [
        "n1210"
    ]
  },
  '/MyAccount/AccountProRate_86308': function () {
    return [
        "d120802", "d120803", "d120804"
    ]
  },
  '/MyAccount/AccounTcarryoOverCheck_86308': function () {
    return [
        "d121002dz", "d121003dz", "d121004dz", "d121005dz"
    ]
  },
  '/MyAccount/ManualTransfer_77335': function () {
    return [
        "d110702", "d110703"
    ]
  },
  '/MyAccount/CostManage_77335': function () {
    return [
        "d110902", "d110903", "d110904", "d110905", "d110906", "d110907", "d110908", "d110909", "d110910", "d110911", "d110912"
    ]
  },
  '/Notice/Index': function () {
    return [
        "n130201", "n130202", "n130203", "n130204"
    ]
  },
  '/WarehouseManagement/supplier': function () {
    return [
        "r1010101", "r1010102", "r1010103", "r1010104"
    ]
  },
  '/WarehouseManagement/materialCode': function () {
    return [
        "r1010201", "r1010202", "r1010203", "r1010204", "r105"
    ]
  },
  '/WarehouseManagement/warehousingData': function () {
    return [
        "r1010301", "r1010302", "r1010303", "r1010304"
    ]
  },
  '/WarehouseManagement/intoWarehouseManagement': function () {
    return [
        "r1020101", "r1020102", "r1020103", "r1020104", "r1020105", "r1020108", "r1020109", "r104"
    ]
  },
  '/WarehouseManagement/indetail': function () {
    return [
      	"r1020101", "r1020102", "r1020103", "r1020104", "r1020105", "r1020108"
    ]
  },
  '/WarehouseManagement/addOrEditIntoWarehouse': function () {
    return [
        "r1020102", "r1020103", "r1020108", "r1020202", "r1020203", "r1020208", "r1030202", "r1030203"
    ]
  },
  '/WarehouseManagement/outofWarehouseManagement': function () {
    return [
        "r1020201", "r1020202", "r1020203", "r1020204", "r1020205", "r1020208", "r1020209", "r1020210", "r1020211"
    ]
  },
  '/WarehouseManagement/outdetail': function () {
    return [
        "r1020201", "r1020202", "r1020203", "r1020204", "r1020205", "r1020208"
    ]
  },
  '/WarehouseManagement/inAndOutLaundryList': function () {
    return [
        "r1020301", "r1020304", "r1020305"
    ]
  },
  '/WarehouseManagement/stockTaking': function () {
    return [
      	"r1030102", "r1030103", "r1030104", "r1030105"
    ]
  },
  '/WarehouseManagement/inventoryAdjustment': function () {
    return [
        "r1030201", "r1030202", "r1030203", "r1030204", "r1030205", "r1030206", "r1030207"
    ]
  },
  '/WarehouseManagement/WarehouseTemplate': function () {
    return [
        "n140601", "n140602", "n140603"
    ]
  },
  '/WarehouseManagement/ImportDelivery': function () {
    return [
        "r106", "r10601", "r10602", "r10603"
    ]
  },
  '/WarehouseManagement/ImportDeliveryorder': function () {
    return [
        "r106", "r10601", "r10602", "r10603"
    ]
  },
  '/WarehouseManagement/ImportRecord': function () {
    return [
        "r104", "r10401", "r10402", "r10403"
    ]
  },
  '/WarehouseManagement/ImportRecordorder': function () {
    return [
        "r104", "r10401", "r10402", "r10403"
    ]
  },
  '/WarehouseManagement/ImportRecordMaterial': function () {
    return [
        "r105", "r10501", "r105402", "r10503"
    ]
  },
  '/WarehouseManagement/judgestockTaking': function () {
    return [
        "r10304", "r1030401"
    ]
  },
  '/WarehouseManagement/judgestockTakingjournal': function () {
    return [
        "r10304", "r1030401"
    ]
  },
  '/WarehouseManagement/intoWarehouseManagementorder': function () {
    return [
        "r1070101", "r1070102", "r1070103", "r1070104", "r1070105", "r1070108", "r1070109", "r10701010", "r10701011", "r104"
    ]
  },
  '/WarehouseManagement/addOrEditIntoWarehouseorder': function () {
    return [
        "r1070102", "r1070103", "r1070108", "r1070202", "r1070203", "r1070208", "r1030202", "r1030203"
    ]
  },
  '/WarehouseManagement/outofWarehouseManagementorder': function () {
    return [
        "r1070201", "r1070202", "r1070203", "r1070204", "r1070205", "r1070208", "r1070208", "r1070209", "r10702010", "r10702011", "r10601"
    ]
  },
  '/SMSPlatform/AddressBook': function () {
    return [
        "j11", "j1101", "j1102", "j1103", "j1104", "j1105", "j1106"
    ]
  },
  '/SMSPlatform/smsRecord': function () {
    return [
        "j1401", "j1402"
    ]
  },
  '/SMSPlatform/BindWeChat': function () {
    return [
      	"j1501", "j1502"
    ]
  },
  '/WriteOffDetailed/DetailedIndex': function () {
    return [
        "c110801", "c110802", "c110803", "c110804", "c110805", "c110806", "c110807", "c110808", "c110809", "c110810", "c110811", "c110812", "c110813", "c110832", "c110814", "c110815", "c110816", "c110817", "c110818", "c110819", "c110820",
        "c110821", "c110822", "c110823", "c110824", "c110825", "c110826", "c110827", "c110828", "c110829", "c110830", "c110831", "c110833", "c110834", "c110835", "c110836", "c110837", "c110838", "c110839", "c110840", "c110841", "c110842", "c110843", "c110844",
        "c110839sb", "c110840sb", "c110841sb", "c110842sb", "c110843sb","c110844yy", "c110845yy", "c110846yy", "c110847yy", "c110848yy", "c110849yy", "c110850yy","c110845","c110846","c110847","c110848","c110849","c110850","c110851","c110852","c110853","c110854","c110861","c110862","c110863",
        "c110855","c110856","c110857yk","c110858yk","c110859yk","c110861yk","c110860","c110762","c110864","c110271","c110272","c110861"
    ]
  },
  '/TransportResources/VehicleArchives': function () {
    return [
        "e1102", "e1103", "e1104", "e1105", "e1106"
    ]
  },
  '/TransportResources/OperationExamination': function () {
    return [
        "e1201", "e1202", "e1203", "e1204", "e1205", "e1206", "e1207"
    ]
  },
  '/TransportResources/Maintenance': function () {
    return [
        "e1301", "e1302", "e1303", "e1304", "e1305", "e1306", "e13dz01", "e13dz02", "e13dz03"
    ]
  },
  '/TransportResources/Carrier': function () {
    return [
        "e1401", "e1402", "e1403", "e1404", "e1405", "e1406", "e1407"
    ]
  },
  '/TransportResources/DeliveryFeeStandard': function () {
    return [
        "e1502", "e1503", "e1504"
    ]
  },
  '/TransportResources/Lineprice75313': function () {
    return [
        "e19dz01", "e19dz02", "e19dz03"
    ]
  },
  '/TransportResources/Linesystem': function () {
    return [
        "e2001", "e2002", "e2003", "e2004", "e2005", "e2006"
    ]
  },
  '/CustomerPickUp/Index': function () {
    return [
        "a11301", "a11302", "a11303", "a11304", "a11305", "a11306", "a11307", "a11308", "a11309", "a11310", "a11311"
    ]
  },
  '/CustomerPickUp/PickUpSingle': function () {
    return [
        "a11301", "a11302", "a11303", "a11304", "a11305", "a11306", "a11307", "a11308", "a11309", "a11310","a11315"
    ]
  },
  '/CustomerPickUp/PickUpList': function () {
    const tmscode = window.getNewUserInfo().TMSCode
    let list = [
        "a11301", "a11302", "a11303", "a11304", "a11305", "a11306", "a11307", "a11308", "a11309", "a11310", "a1308", "a11315"
    ]
    if(tmscode == "86270"){
        list.push("a11315dz")
    }
    return list
  },
  '/CustomerPickUp/PickUpBatch': function () {
    const tmscode = window.getNewUserInfo().TMSCode
    let list = [
        "a11301", "a11302", "a11303", "a11304", "a11305", "a11306", "a11307", "a11308", "a11309", "a11310"
    ]
    if(tmscode == "86270"){
        list.push("a11315dz")
    }
    return list
  },
  '/PermissionGroup/OnlineData': function () {
    return [
        "n110201", "n110202", "n110203", "n110204"
    ]
  },
  '/FinancialPreparation/AccountDefinition': function () {
    return [
        "c150101", "c150102"
    ]
  },
  '/FinancialPreparation/b_dj_content': function () {
    return [
        "c150302", "c150303", "c150304"
    ]
  },
  '/FinancialPreparation/B_ACCOUNT_CN_BILLTYPE': function () {
    return [
        "c150401", "c150402", "c150403", "c150404", "c150405", "c150406", "c150407"
    ]
  },
  '/FinancialPreparation/WriteOffSubject': function () {
    return [
        "c150201", "c150202"
    ]
  },
  '/FinancialPreparation/Subordinateline': function () {
    return [
        "c150801", "c150802", "c150803"
    ]
  },
  '/SendPack_SB/CustomerYuyue_SB': function () {
    return [
        "sb102", "sb103", "sb104"
    ]
  },
  '/SendPack_SB/NewCustomerYuyue_SB': function () {
    return [
        "sb102", "sb103", "sb104"
    ]
  },
  '/SendPack_SB/SendOrders_SB': function () {
    return [
        "sb302", "sb303", "sb304", "sb305", "sb306", "sb307", "sb308", "sb309", "sb0310", "sb0311", "sb0312"
    ]
  },
  '/SendPack_SB/NewSendOrders_SB': function () {
    return [
        "sb3010", "sb3011", "sb3012"
    ]
  },
  '/SendPack_SB/SendOrders_Modify_SB': function () {
    return [
        "sb302", "sb303", "sb304", "sb305", "sb306", "sb307", "sb308", "sb309", "sb3010", "sb3011", "sb3012"
    ]
  },
  '/SendPack_SB/Chauffeurpick_SB': function () {
    return [
        "sb402", "sb403", "sb404", "sb405"
    ]
  },
  '/SendPack_SB/AddChauffeurpick_SB': function () {
    return [
        "sb402", "sb403", "sb404"
    ]
  },
  '/SendPack_SB/Chauffeurpick_Info_SB': function () {
    return [
        "sb402", "sb403", "sb404", "sb405"
    ]
  },
  '/SendPack_SB/SignComplete_SB': function () {
    return [
        "sb602", "sb603", "sb604", "sb605"
    ]
  },
  '/SendPack_SB/NoneSignComplete_SB': function () {
    return [
        "sb602", "sb603", "sb604", "sb605"
    ]
  },
  '/SendPack_SB/AddSignComplete_SB': function () {
    return [
        "sb602", "sb603", "sb604", "sb605"
    ]
  },
  '/SendPack_SB/PL_NoneSignComplete_SB': function () {
    return [
        "sb602", "sb603", "sb604", "sb605"
    ]
  },
  '/SendPack_SB/catch_SB': function () {
    return [
        "sb1901", "sb1902", "sb1903", "sb1904", "sb1905", "sb1906", "sb1907", "sb1908", "sb1909", "sb1910", "sb1911"
    ]
  },
  '/SendPack_SB/ChauffeurInfo_SB': function () {
    return [
        "sb801", "sb802", "sb803", "sb804"
    ]
  },
  '/SendPack_SB/ChauffeurInfoAddOrEdit_SB': function () {
    return [
        "a1701", "a1702", "a1703", "a1704", "a1705", "a1706", "a1707"
    ]
  },
  '/baseSetting/ShippernoSetting': function () {
    return [
        "n1501", "n150101", "n150102", "n150103"
    ]
  },
  '/baseSetting/DailibsiteSetting': function () {
    return [
        "n1502", "n150201", "n150202", "n150203", "n150204"
    ]
  },
  '/VehicleOilCard/OilCardMaterial': function () {
    return [
        "f1102", "f1103", "f1104", "f19"
    ]
  },
  '/VehicleOilCard/OilCardReg': function () {
    return [
        "f1202", "f1203", "f1204", "f1205", "f1206"
    ]
  },
  '/VehicleOilCard/OilCardGive': function () {
    return [
        "f1302", "f1303", "f1304", "f1305"
    ]
  },
  '/VehicleOilCard/OilCardOutStorage': function () {
    return [
        "f1502", "f1503"
    ]
  },
  '/VehicleOilCard/OilCardRecycling': function () {
    return [
        "f1601", "f1602", "f1604", "f1603"
    ]
  },
  '/VehicleOilCard/ImportCardMaterialMain': function () {
    return [
        "f19", "f1901", "f1902", "f1903"
    ]
  },
  '/VehicleOilCard/CardMaterialTemplate': function () {
    return [
        "n140701", "n140702", "n140703"
    ]
  },
  '/FinancialInstruments/ChangeWaybill': function () {
    return [
        "c130401", "c130402", "c130403", "c130404", "c130405"
    ]
  },
  '/zzjg/Index': function () {
    return [
        "n11010101", "n11010102", "n11010103", "n11010104", "n11010201", "n11010202", "n11010203", "n11010204", "n11010301", "n11010302", "n11010303", "n11010304", "n11010305"
    ]
  },
  '/qsRegister/Index': function () {
    return [
        "a11601", "a11602", "a11603", "a11604", "a11605", "a11606", "a11607", "a11608", "a11609", "a11610", "a11616", "a11620", "a11621", "a11622", "a1308"
    ]
  },
  '/qsRegister/qsSingle': function () {
    return [
        "a11601", "a11602", "a11603", "a11604", "a11605", "a11606", "a11607", "a11608", "a11609", "a11610", "a11616", "a11623"
    ]
  },
  '/qsRegister/qsList': function () {
    const tmscode = window.getNewUserInfo().TMSCode
    let list = [
        "a11601", "a11602", "a11603", "a11604", "a11605", "a11606", "a11607", "a11608", "a11609", "a11610", "a11616", "a11623"
    ]
    if(tmscode == "86270"){
        list.push("a11623dz")
    }
    return list
  },
  '/qsRegister/qsBatch': function () {
    const tmscode = window.getNewUserInfo().TMSCode
    let list = [
        "a11601", "a11602", "a11603", "a11604", "a11605", "a11606", "a11607", "a11608", "a11609", "a11610"
    ]
    if(tmscode == "86270"){
        list.push("a11623dz")
    }
    return list
  },
  '/Settlement/DriverAuth': function () {
    return [
        "kp1121", "kp1122", "kp1123", "kp1124"
    ]
  },
  '/Settlement/VehicleAuth': function () {
    return [
        "kp1221", "kp1222"
    ]
  },
  '/Settlement/PayeeAuth': function () {
    return [
        "e21", "e2101", "e2102", "e2103", "e2104", "e21dz1"
    ]
  },
  '/Settlement/YOrderLists': function () {
    return [
        "kp1311", "kp1312", "kp1313", "kp1314", "kp1315", "kp1316"
    ]
  },
  '/Settlement/SOrderLists': function () {
    return [
        "kp1321"
    ]
  },
  '/Settlement/Openticket': function () {
    return [
        "kp1411", "kp1412"
    ]
  },
  '/Settlement/Invoiced': function () {
    return [
        "kp1421"
    ]
  },
  '/MybSupplyManagement/PzFindCarList': function () {
    return [
        "zckp211", "zckp215", "zckp213", "zckp212", "zckp214", "zckp217", "zckp216", "zckp219"
    ]
  },
  '/InventoryManagement/SupplierManagement': function () {
    return [
        "cc1030101", "cc1030102", "cc1030103"
    ]
  },
  '/InventoryManagement/CJManagement': function () {
    return [
      	"cc1030301", "cc1030302", "cc1030303"
    ]
  },
  '/InventoryManagement/CustomerInformation': function () {
    return [
        "cc1030201", "cc1030202", "cc1030203"
    ]
  },
  '/InventoryManagement/CommodityManagement': function () {
    return [
        "cc10401", "cc10402", "cc10403", "cc10404"
    ]
  },
  '/InventoryManagement/WarehouseManagement': function () {
    return [
        "cc10601", "cc10602", "cc10603", "cc10604"
    ]
  },
  '/InventoryManagement/InboundMgn': function () {
    return [
        "cc10801", "cc10802", "cc10803", "cc10804", "cc10805"
    ]
  },
  '/InventoryManagement/PurchaseOrder': function () {
    return [
        "cc10701", "cc10702", "cc10703", "cc10704", "cc10705", "cc10706", "cc10707"
    ]
  },
  '/InventoryManagement/InternalBusiness': function () {
    return [
        "cc1090101", "cc1090102", "cc1090103", "cc1090104", "cc1090105", "cc1090106", "cc1090107"
    ]
  },
  '/InventoryManagement/InventoryChecking': function () {
    return [
        "cc1090201", "cc1090202", "cc1090203", "cc1090204", "cc1090205", "cc1090206"
    ]
  },
  '/InventoryManagement/InventoryProfit': function () {
    return [
        "cc1090301", "cc1090302", "cc1090303", "cc1090304", "cc1090305", "cc1090306"
    ]
  },
  '/InventoryManagement/InventoryLoss': function () {
    return [
        "cc1090401", "cc1090402", "cc1090403", "cc1090404", "cc1090405", "cc1090406"
    ]
  },
  '/InventoryManagement/OutboundMgn': function () {
    return [
        "cc101001", "cc101002", "cc101003", "cc101004", "cc101005", "cc101006"
    ]
  },
  '/InventoryManagement/BasicSettings': function () {
    return [
        "cc10101", "cc10102", "cc10103"
    ]
  },
  '/InventoryManagement/PurchaseReturn': function () {
    return [
        "cc10110101", "cc10110102", "cc10110103", "cc10110104", "cc10110105", "cc10110106"
    ]
  },
  '/InventoryManagement/SalesReturns': function () {
    return [
        "cc10110201", "cc10110202", "cc10110203", "cc10110204", "cc10110205", "cc10110206"
    ]
  },
  '/InventoryManagement/ImportSettings': function () {
    return [
        "cc1020101", "cc1020102", "cc1020103"
    ]
  },
  '/InventoryManagement/INStoreImportSettings': function () {
    return [
        "cc1020201", "cc1020202", "cc1020203"
    ]
  },
  '/InventoryManagement/InStoreImportCommodity': function () {
    return [
        "cc1080501", "cc1080502", "cc1080503"
    ]
  },
  '/InventoryManagement/ImportCommodity': function () {
    return [
        "r105", "r10501", "r105402", "r10503"
    ]
  },
  '/InventoryManagement/OutStoreImportSettings': function () {
    return [
        "cc1020301", "cc1020302", "cc1020303"
    ]
  },
  '/InventoryManagement/OutStoreImportCommodity': function () {
    return [
        "cc1080501", "cc1080502", "cc1080503"
    ]
  },
  '/InventoryManagement/PlannedStorage': function () {
    return [
        "cc10701", "cc10702", "cc10703", "cc10704", "cc10705", "cc10706", "cc10707"
    ]
  },
  '/InventoryManagement/PlanOutOfStock': function () {
    return [
        "cc10110101", "cc10110102", "cc10110103", "cc10110104", "cc10110105", "cc10110106"
    ]
  },
  '/InventoryManagement/positionIntervalSetting': function () {
    return [
        "n1208"
    ]
  },
  '/InventoryManagement/storageFeeIndex': function () {
    return [
      	"n1201"
    ]
  },
  '/Hlht/UpstreamInformation': function () {
    return [
        "a1301", "a1302", "a1303", "a1304", "a1305", "a1306", "a1307", "a1308", "a1309", "a1310", "a1308", "a1312", "a1321", "a11", "a1322", "a1323", "a1324", "a1325", "q125", "a1326", "a1327", "q201"
    ]
  },
  '/PleaseInquire/PleaseInquire_Index': function () {
    return [
        "c110401", "c110402", "c110403", "c110404", "c110405", "c110406", "c110407", "c110408", "c110409", "c110410", "c110411", "c110412", "c110413", "c110414"
    ]
  },
  '/PleaseInquire/PleaseInquireWriteoff': function () {
    return [
        "c110201", "c110202", "c110203", "c110204", "c110205", "c110206", "c110207", "c110208", "c110209", "c110210", "c110211", "c110212", "c110223", "c110213", "c110214", "c110215", "c110216", "c110217", "c110218", "c110219", "c110220", "c110221", "c110222", "c110224", "c110225", "c110226", "c110227", "c110228", "c110229", "c110230", "c110231", "c110232", "c110233", "c110234", "c110235", "c110236", "c110237", "c110238",
        "c110235sb", "c110236sb", "c110237sb", "c110238sb", "c110239sb","c110272",
        "c110240yy", "c110241yy", "c110242yy", "c110243yy", "c110244yy", "c110245yy", "c110246yy",
        "c110240","c110241","c110242","c110243","c110244","c110245","c110246","c110247","c110248","c110249","c110250","c110251","c110252","c110253","c110254","c110260","c110261","c110264","c110263","c110262","c110268"
    ]
  },
  '/PleaseInquire/PleaseReview': function () {
    return [
        "c110301", "c110302", "c110303", "c110304", "c110305", "c110306"
    ]
  },
  '/czy/Index': function () {
    return [
        "n110301", "n110302", "n110303", "n110304"
    ]
  },
  '/ztgz/Index': function () {
    return [
        "a1901", "a1902", "a1903", "a1904", "a1905", "a1907"
    ]
  },
  '/ztgz/CarGZ': function () {
    return [
        "a1903", "a1904", "a1905", "a1906", "a1907"
    ]
  },
  '/ShortHauls/ShortHaulConnection': function () {
    return [
        "a1701", "a1702", "a1703", "a1704", "a1705", "a1706", "a1707","a1709"
    ]
  },
  '/ShortHauls/ShorHaulsUPD_bcqd': function () {
    return [
        "a1703", "a1704", "a1705", "a1706", "a1707"
    ]
  },
  '/ShortHauls/NewShortLighter': function () {
    return [
        "a1701", "a1702", "a1703", "a1704", "a1705", "a1706", "a1707", "a1709"
    ]
  },
  '/rptMana/rptModelMana': function () {
    return [
      	"n140101", "n140102", "n140103", "n140104"
    ]
  },
  '/QuickFindResult/Index': function () {
    return [
        "q24","q25","q106", "q103", "q107", "q108", "q109", "q101", "q102", "q105", "q104", "q121", "q123", "q124",
        "q125", "q126", "q127", "q128", "q129", "q130", "q131", "q132", "q133", "a1324", "a12345", "c131601", "c131602", "c131603", "c131604", "a1326",
        "sb1", "sb11", "sb104","q137","q138","q139","q140","q1341","q142","q143","q144","q145","q146","q147"
    ]
  },
  '/QuickFindResult/WaybillTracking': function () {
    return [
        "q1370101", "q1370102", "q1370103"
    ]
  },
  '/TrackingInTransit/OutsourcedGoods': function () {
    return [
      	"a1601", "a1602", "a1603", "a1604", "a1605", "a1606", "a1607", "a1609", "a1610"
    ]
  },
  '/TrackingInTransit/Track': function () {
    return [
        "a1602", "a1603", "a1604", "a1605", "a1606", "a1607"
    ]
  }
}

export default strrole
